import { createSlice } from "@reduxjs/toolkit";

const initialRefine = {
    mainIndexSearchTerm: null,
};

const refinesSlice = createSlice({
    name: "refineSearch",
    initialState: initialRefine,
    reducers: {
        refineMainIndexSearch(state, action) {
            state.mainIndexSearchTerm = action.payload;
        },
    },
});

export default refinesSlice;
